import React, { lazy, Suspense, useState } from "react";
import {
  DirectionsRenderer,
  DrawingManager,
  DrawingManagerF,
  GoogleMap,
  InfoWindowF,
  MarkerClustererF,
  MarkerF,
  OverlayViewF,
  PolygonF,
  Polyline,
  PolylineF,
  useJsApiLoader,
} from "@react-google-maps/api";
import {
  addToFavorites,
  deleteArea,
  getListingData,
  removeFromFavorites,
} from "../services/api";
import { useDispatch, useSelector } from "react-redux";
import {
  pushUserFavoritesData,
  setCurrentRoute,
  setFilterValues,
  setListings,
  setMapCenter,
  setMapZoom,
  setPrintQueue,
  setRefetch,
  setSelectedListing,
  setUserFavoritesData,
} from "../store/reducers/listingReducer";
import { useNavigate } from "react-router-dom";
import { config } from "../config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMinus,
  faPen,
  faPlus,
  faSave,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import SaveRoute from "./SaveRoute";
import { debounce } from "lodash";
import { AssignArea } from "./AssignArea";
import { baseQueryAPI } from "../services/baseQuery";
import { Spinner } from "./ui/Spinner";
import { AreaPolygon } from "./AreaPolygon";
import { EditArea } from "./EditArea";
//import { MarkerCluster } from "./mapElements/MarkerCluster";

const AddListing = lazy(() => import("./AddListing"));

interface IProps {}
const mapLibraries = ["drawing"];

const GoogleMapContainer = (props: IProps) => {
  /*const {
        address
    } = props;*/
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const [location, setLocation] = useState<any>({
    lat: 37.09024,
    lng: -95.712891,
  });

  const [homeLocation, setHomeLocation] = useState<any>({
    lat: 37.09024,
    lng: -95.712891,
  });

  const [newListingLocation, setNewListingLocation] = useState<any>(null);
  const [map, setMap] = React.useState<any>(null);

  const listings = useSelector((state: any) => state.listingReducer.listings);
  const selectedListing = useSelector(
    (state: any) => state.listingReducer.selectedListing
  );
  const refetch = useSelector((state: any) => state.listingReducer.refetch);
  const filterValues = useSelector(
    (state: any) => state.listingReducer.filterValues
  );
  const favoritesShow = useSelector(
    (state: any) => state.listingReducer.favoritesShow
  );
  const addListingShow = useSelector(
    (state: any) => state.listingReducer.addListingShow
  );
  const logged = useSelector((state: any) => state.listingReducer.logged);
  const remindersShow = useSelector(
    (state: any) => state.listingReducer.remindersShow
  );
  const routesShow = useSelector(
    (state: any) => state.listingReducer.routesShow
  );
  const teamActivityShow = useSelector(
    (state: any) => state.listingReducer.teamActivityShow
  );
  const hoveredListing = useSelector(
    (state: any) => state.listingReducer.hoveredListing
  );
  const userFavorites = useSelector(
    (state: any) => state.listingReducer.userFavorites
  );
  const printQueue = useSelector(
    (state: any) => state.listingReducer.printQueue
  );
  const userData = useSelector((state: any) => state.listingReducer.userData);
  const mapCenter = useSelector((state: any) => state.listingReducer.mapCenter);
  const mapZoom = useSelector((state: any) => state.listingReducer.mapZoom);

  const [showInfoWindow, setShowInfoWindow] = React.useState<boolean>(false);
  //const [showAddListing, setShowAddListing] = React.useState<boolean>(false);
  const [activeTooltipId, setActiveTooltipId] = React.useState<string>("");
  const [isStreetView, setIsStreetView] = React.useState<boolean>(false);
  const [clickedListing, setClickedListing] = React.useState<any>(null);
  const [drawingMode, setDrawingMode] = React.useState<any>(null);
  const [polygonOverlay, setPolygonOverlay] = React.useState<any>(null);
  const [selectedPolygon, setSelectedPolygon] = React.useState<any>(null);
  const [showEditArea, setShowEditArea] = React.useState(false);
  const currentRoute = useSelector(
    (state: any) => state.listingReducer.currentRoute
  );

  //const [source, setSource] = React.useState<any>('');
  //const [destinations, setDestinations] = React.useState<any>([]);
  const [routeEnabled, setRouteEnabled] = React.useState<boolean>(false);
  const [autoOptimizeRoute, setAutoOptimizeRoute] =
    React.useState<boolean>(false);
  //const [directionsResponse, setDirectionsResponse] = React.useState<any>(null);
  //const [waypoints, setWaypoints] = React.useState<any>(null);
  const [filteredListings, setFilteredListings] = React.useState<any>([]);
  const [path, setPath] = React.useState<any>([]);
  const [directions, setDirections] = React.useState<any>(null);
  const [printPath, setPrintPath] = React.useState<any>([]);
  const [printProperties, setPrintProperties] = React.useState<any>([]);
  const [editRoute, setEditRoute] = React.useState(null);

  const clustererRef = React.useRef<any>();
  const [draw, setDraw] = React.useState<boolean>(false);
  const [print, setPrint] = React.useState(false);
  const [drawArea, setDrawArea] = React.useState(false);
  const [assignArea, setAssignArea] = React.useState([]);
  const [selectedArea, setSelectedArea] = React.useState<any>(null);
  const [edit, setEdit] = React.useState<boolean>(false);
  const drawRef = React.useRef<boolean>(draw);
  const printRef = React.useRef<boolean>(print);
  const mapRef = React.useRef<any>(map);
  const listingsRef = React.useRef<any>(listings);
  const filterValuesRef = React.useRef<any>(filterValues);
  const drawingManagerRef = React.useRef<any>(null);

  const onLoadDrawing = React.useCallback((drawingManager: any) => {
    drawingManagerRef.current = drawingManager;
  }, []);

  const { data: teamArea, refetch: reFetchTeamArea } =
    baseQueryAPI.useTeamAreasQuery("");
  const { data: myArea } = baseQueryAPI.useAreaQuery("");

  React.useEffect(() => {
    drawRef.current = draw;
  }, [draw]);

  React.useEffect(() => {
    printRef.current = print;
  }, [print]);

  React.useEffect(() => {
    mapRef.current = map;
  }, [map]);

  React.useEffect(() => {
    listingsRef.current = listings;
  }, [filteredListings]);

  React.useEffect(() => {
    filterValuesRef.current = filterValues;
  }, [filterValues]);

  React.useEffect(() => {
    if (drawingManagerRef.current) {
      drawingManagerRef.current.setDrawingMode(drawingMode);
    }
  }, [drawingMode]);

  React.useEffect(() => {
    if (mapCenter && mapCenter.search) {
      // Set map zoom to a closer view, e.g., 10 or 12.
      map?.setZoom(mapZoom); // Adjust zoom level as needed
      map?.panTo(new window.google.maps.LatLng(mapCenter.lat, mapCenter.lng));
    }
  }, [map, mapCenter, mapZoom]);

  React.useEffect(() => {
    if (currentRoute) {
      setPath(JSON.parse(currentRoute.path));
    } else setPath([]);
  }, [currentRoute]);

  //   React.useEffect(() => {
  //     const cancelToken = axios.CancelToken.source();
  //     (async () => {
  //       if (refetch) {
  //         try {
  //           let listingResponse = await getListingData(cancelToken.token);
  //           dispatch(setListings(listingResponse.data.data));
  //           dispatch(setRefetch(false));
  //           setNewListingLocation(null);
  //         } catch (error) {
  //           if (axios.isCancel(error)) {
  //             //console.log('Request canceled:', error.message);
  //           } else {
  //             //console.error('An error occurred:', error);
  //           }
  //         }
  //       }
  //     })();

  //     return () => {
  //       cancelToken.cancel("Component unmounted, request canceled");
  //     };
  //   }, [refetch]);

  React.useEffect(() => {
    if (!addListingShow) {
      setNewListingLocation(null);
    }
  }, [addListingShow]);

  React.useEffect(() => {
    const filtered = filterListing();
    setFilteredListings(filtered);
  }, [filterValues, listings]);

  React.useEffect(() => {
    console.log("list changed", filteredListings.length);
    if (filteredListings.length > 0) {
      // Workaround for markers not rendering when the map is changed to new location where the data is loaded from the api
      // setTimeout(
      //   map?.panTo({
      //     lat: map?.center?.lat() + 0.0000050000001,
      //     lng: map?.center?.lng(),
      //   }),
      //   150
      // );
    }
    clustererRef.current?.repaint();
  }, [filteredListings.length]);

  React.useEffect(() => {
    if (autoOptimizeRoute) {
      fetchDirections();
    } else {
      setDirections(null);
    }
  }, [autoOptimizeRoute, printPath]);

  /*React.useEffect(() => {
        clustererRef.current?.repaint()
    }, [hoveredListing])*/

  function filterListing() {
    let returnListings = listings;
    /*if (filterValues.filterState && filterValues.filterState !== '') {
            returnListings = listings.filter((item: any) => item.state === filterValues.filterState);
            //console.log('state-', returnListings)
        }*/
    if (filterValues.filterTime && filterValues.filterTime !== "") {
      let timeCheck =
        Math.floor(Date.now() / 1000) - filterValues.filterTime * 24 * 60 * 60;
      //console.log(timeCheck)
      returnListings = returnListings.filter(
        (item: any) => item.time_listed >= timeCheck
      );
      //console.log('time-', returnListings)
    }
    /*if (filterValues.filterLeadOwner && filterValues.filterLeadOwner !== '') {
            returnListings = returnListings.filter((item: any) => item.lead_owner?.toLowerCase() === filterValues.filterLeadOwner.toLowerCase());
            //console.log('owner-', returnListings)
        }*/
    if (filterValues.filterLeadStatus && filterValues.filterLeadStatus !== "") {
      returnListings = returnListings.filter(
        (item: any) =>
          item.lead_status_options_public_id === filterValues.filterLeadStatus
      );
      //console.log('owner-', returnListings)
    }

    if (
      filterValues.filterBySourceType &&
      filterValues.filterBySourceType !== ""
    ) {
      returnListings = returnListings.filter(
        (item: any) => item.source_type === filterValues.filterBySourceType
      );
    }

    if (filterValues.filterBounds && filterValues.filterBounds !== "") {
      // returnListings = returnListings.filter(
      //   (item: { latitude: string; longitude: string }) => {
      //     const lat = parseFloat(item.latitude);
      //     const lng = parseFloat(item.longitude);
      //     return filterValues.filterBounds.contains(
      //       new window.google.maps.LatLng(lat, lng)
      //     );
      //   }
      // );
      const containsClickedListing = returnListings.some((item: any) => {
        return item.listing_unique_id === clickedListing?.listing_unique_id;
      });
      if (!containsClickedListing) {
        setClickedListing(null);
      }
      //console.log('owner-', returnListings)
    }

    if (filterValues.filterBuiltYear) {
      returnListings = returnListings.filter(
        (itm: any) =>
          Number(itm.year_built) >= filterValues.filterBuiltYear.start &&
          Number(itm.year_built) <= filterValues.filterBuiltYear.end
      );
    }

    if (filterValues.filterBathrooms) {
      returnListings = returnListings.filter(
        (itm: any) => Number(itm.bathrooms) >= filterValues.filterBathrooms
      );
    }

    if (filterValues.filterBedrooms) {
      returnListings = returnListings.filter(
        (itm: any) => Number(itm.bedrooms) >= filterValues.filterBedrooms
      );
    }
    return returnListings;
  }

  const geocodeAddress = async () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        setHomeLocation({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
        // Set map zoom to a closer view, e.g., 10 or 12.
        map?.setZoom(16); // Adjust zoom level as needed
        map?.panTo(
          new window.google.maps.LatLng(
            position.coords.latitude,
            position.coords.longitude
          )
        );
        dispatch(
          setMapCenter({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          })
        );
      });
    } else {
      console.log("could not geocode");
    }
  };

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyCclBCu30QD5vsNQKwg8PKrn2EofxY6YP4",
    libraries: mapLibraries as any,
    channel: "monthly",
  });

  const onLoad = React.useCallback(function callback(map: any) {
    geocodeAddress();
    setMap(map);
    let thePanorama = map.getStreetView();
    window.google.maps.event.addListener(
      thePanorama,
      "visible_changed",
      function () {
        let isVisible = thePanorama.getVisible();
        //console.log(isVisible)
        if (isVisible) {
          setIsStreetView(true);
        } else {
          setIsStreetView(false);
        }
      }
    );
    const debouncedFilterListings = debounce(filterListingsInView, 500); // Adjust debounce time as needed

    window.google.maps.event.addListener(map, "idle", () => {
      debouncedFilterListings();
    });
  }, []);

  const onUnmount = React.useCallback(function callback(map: any) {
    setMap(null);
  }, []);

  function markerClick(listingSelected: any, event: any) {
    if (!logged) {
      return;
    }
    const position = {
      lat: parseFloat(listingSelected.latitude),
      lng: parseFloat(listingSelected.longitude),
    };
    if (event.domEvent.ctrlKey || event.domEvent.metaKey) {
      let newState: any;
      let newPropertyState: any;
      const index = printPath.findIndex(
        (itm: any) => itm.lat === position.lat && itm.lng === position.lng
      );
      if (index !== -1) {
        newState = printPath.slice(0, index).concat(printPath.slice(index + 1));
      } else newState = [...printPath, position];

      const PropertyIndex = printProperties.findIndex(
        (itm: any) => itm === listingSelected.listing_unique_id
      );
      if (PropertyIndex !== -1) {
        newPropertyState = printProperties
          .slice(0, index)
          .concat(printProperties.slice(index + 1));
      } else
        newPropertyState = [
          ...printProperties,
          listingSelected.listing_unique_id,
        ];

      setPrintPath(newState);
      setPrintProperties(newPropertyState);
      // if (listingSelected.source_link) {
      //   dispatch(setPrintQueue([...printQueue, listingSelected.source_link]));
      // }
      return;
    }
    /*const filteredByState = listings.filter((listing: any) => listing.state === listingSelected.state);
        setFilteredListings(filteredByState);*/

    /*dispatch(setFilterValues({
                filterState: listingSelected.state
            }
        ));*/
    //setShowInfoWindow(true);
    //setActiveTooltipId(listingSelected.listing_unique_id)
    setClickedListing(listingSelected);
    // Optionally, zoom in and center the map on the selected pin
    //map?.setZoom(12); // Adjust zoom level as needed
    //map?.panTo(new window.google.maps.LatLng(listingSelected.latitude, listingSelected.longitude));
    /*setLocation({
            lat: parseFloat(listingSelected.latitude),
            lng: parseFloat(listingSelected.longitude)
        })*/
    //navigate(config.path + "listing/" + listingSelected.listing_unique_id);
    //dispatch(setSelectedListing(listingSelected.listing_unique_id))
  }

  function handleClickTooltip(listingClicked: any) {
    navigate(config.path + listingClicked.listing_unique_id);
    dispatch(setSelectedListing(listingClicked.listing_unique_id));
  }

  /*const handleMapClick = (event: any) => {
        if (logged) {
            setNewListingLocation({lat: event.latLng.lat(), lng: event.latLng.lng()});
        }
    };*/

  const handleStreetViewClick = (event: any) => {
    if (map) {
      let thePanorama = map.getStreetView();
      let isVisible = thePanorama.getVisible();
      if (isVisible) {
        let clickedLocation = thePanorama.getPosition();
        setNewListingLocation({
          lat: clickedLocation.lat(),
          lng: clickedLocation.lng(),
        });
      }
    }
  };

  const onDeleteArea = async () => {
    if (selectedArea) {
      try {
        await deleteArea({
          ...selectedArea,
        });
        reFetchTeamArea();
      } catch (error) {
        console.error(error);
      }
    }
  };

  /*function onRouteAdded(source: any, destinations: any, autoOptimised?: boolean) {
        setRouteEnabled(true);
        setSource(source);
        setDestinations(destinations);
        let waypointData = [];
        for (let i = 0; i < destinations.length; i++) {
            waypointData.push({location: destinations[i].value, stopover: true})
        }
        setWaypoints(waypointData);
        if (autoOptimised) {
            setAutoOptimizeRoute(autoOptimised)
        }
    }*/

  /*function onRouteRemoved() {
        setRouteEnabled(false)
        setSource(null)
        setDestinations(null);
        setWaypoints(null);
    }*/

  function onRouteAdded(path: any, directions: any, autoOptimised?: boolean) {
    //setRouteEnabled(true);
    setDirections(directions);
    setPath(path);
    setDraw(false);
    /*let waypointData = [];
        for (let i = 0; i < destinations.length; i++) {
            waypointData.push({location: destinations[i].value, stopover: true})
        }
        setWaypoints(waypointData);*/
    if (autoOptimised) {
      fetchDirections();
      /*setAutoOptimizeRoute(autoOptimised)*/
    }
  }

  function onRouteRemoved() {
    setDraw(false);
    setPrintPath([]);
    setPrintProperties([]);
    setDirections(null);
  }

  /*const directionsCallback = (response: any) => {
        if (response !== null) {
            if (response.status === 'OK') {
                setDirectionsResponse(response);
            } else {
                console.log('Directions request failed due to ' + response.status);
            }
        }
    };*/

  function isWithinLast24Hours(timeAdded: any) {
    const phpTimestampInMillis = timeAdded * 1000; // Convert PHP timestamp to milliseconds
    const dateAdded: any = new Date(phpTimestampInMillis);
    const currentDate: any = new Date();

    const hoursDifference =
      Math.abs(currentDate - dateAdded) / (1000 * 60 * 60);
    return hoursDifference <= 24;
  }

  const options = {
    imagePath:
      "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m", // so you must have m1.png, m2.png, m3.png, m4.png, m5.png and m6.png in that folder
  };

  const handleMapClick = React.useCallback(
    (e: any) => {
      setClickedListing(null);
      setSelectedArea(null);
      if (!drawRef.current) {
        return;
      }
      const newPath = [...path, { lat: e.latLng.lat(), lng: e.latLng.lng() }];
      setPath(newPath);
    },
    [path]
  );

  const fetchDirections = React.useCallback(() => {
    if (printPath.length < 2) return;

    const directionsService = new window.google.maps.DirectionsService();
    const origin = printPath[0];
    const destination = printPath[printPath.length - 1];
    const waypoints = printPath
      .slice(1, -1)
      .map((location: any) => ({ location, stopover: false }));

    directionsService.route(
      {
        origin,
        destination,
        waypoints,
        optimizeWaypoints: true,
        travelMode: window.google.maps.TravelMode.DRIVING,
      },
      (result, status) => {
        if (status === window.google.maps.DirectionsStatus.OK) {
          setDirections(result);
        } else {
          console.error(`error fetching directions ${result}`);
        }
      }
    );
  }, [printPath]);

  const filterListingsInView = () => {
    if (!mapRef.current) return;

    const bounds = mapRef.current.getBounds();
    /*const filtered = listingsRef.current.filter((listing: { latitude: string; longitude: string; }) => {
            const lat = parseFloat(listing.latitude);
            const lng = parseFloat(listing.longitude);
            return bounds.contains(new window.google.maps.LatLng(lat, lng));
        });*/
    dispatch(
      setFilterValues({
        ...filterValuesRef.current,
        filterBounds: bounds,
      })
    );
  };

  async function doActionFavorites(listingFav: any) {
    if (!logged) {
      return;
    }
    let params: any = {};
    params["listing_unique_id"] = listingFav.listing_unique_id;
    if (isFavorited(listingFav)) {
      let result = await removeFromFavorites(params);
      if (!result?.data.success) {
        return;
      }
      let newFavorites =
        removeFavoritesItemByListingListingUniqueId(listingFav);
      dispatch(setUserFavoritesData(newFavorites));
    } else {
      let result = await addToFavorites(params);
      if (!result?.data.success) {
        return;
      }
      if (result) {
        dispatch(pushUserFavoritesData(result?.data.data));
      }
    }
  }

  function removeFavoritesItemByListingListingUniqueId(listingFav: any) {
    // Use Array.prototype.filter to create a new array without the target item
    return userFavorites.filter(
      (item: any) => item.listing_unique_id !== listingFav.listing_unique_id
    );
  }

  function isFavorited(listingFav: any) {
    for (let i = 0; i < userFavorites.length; i++) {
      if (userFavorites[i].listing_unique_id === listingFav.listing_unique_id) {
        return true; // Found the target listing_unique_id in the array
      }
    }
    return false;
  }

  const handleCenterChange = () => {
    if (map?.center?.lat() && map?.center?.lng()) {
      dispatch(
        setMapCenter({
          lat: map?.center?.lat(),
          lng: map?.center?.lng(),
        })
      );
    }
  };

  const handleZoomChange = () => {
    if (map?.zoom) {
      dispatch(setMapZoom(map.zoom));
    }
  };

  const onDrawingClose = () => {
    if (drawingMode) {
      setDrawingMode(null);
      polygonOverlay?.setMap(null);
    }
  };

  const onSaveEdit = () => {
    if (selectedArea && selectedPolygon) {
      const paths = selectedPolygon
        .getPath()
        .getArray()
        .map((latLng: any) => {
          return { lat: latLng.lat(), lng: latLng.lng() };
        });
      console.log({ selectedArea, selectedPolygon, paths });
      setShowEditArea(true);
    }
  };

  return isLoaded ? (
    <div id="map-container">
      {isStreetView && logged && (
        <div className={"add-listing-street-view"}>
          <a
            onClick={handleStreetViewClick}
            href="#"
            className="btn btn-primary btn-small btn-rounded icon shadow add-listing"
          >
            <FontAwesomeIcon icon={faPlus} />
            <span> Add listing at current location</span>
          </a>
        </div>
      )}
      {!isStreetView && logged && (
        /*<CreateRoute onRouteAdded={onRouteAdded} onRouteRemoved={onRouteRemoved}
                             enableAutoOptimise={enableAutoOptimise}/>*/
        <div className="absolute bottom-12 flex justify-center items-center w-full gap-x-3">
          {false && !drawingMode && (
            <div>
              <button
                onClick={() => {
                  setPrint(true);
                }}
                className="btn btn-primary px-3 py-1 btn-rounded icon shadow add-listing z-20 relative"
              >
                <FontAwesomeIcon icon={faPlus} />
                <span> Print</span>
              </button>
            </div>
          )}

          {!drawingMode && !selectedArea && userData?.team_owner && (
            <div>
              <button
                onClick={() => {
                  if (drawingManagerRef.current) {
                    setDrawingMode(
                      window.google.maps.drawing.OverlayType.POLYGON
                    );
                  }
                }}
                className="btn btn-primary px-3 py-1 btn-rounded icon shadow add-listing z-20 relative"
              >
                <FontAwesomeIcon icon={faPlus} />
                <span> Draw Area</span>
              </button>
            </div>
          )}

          {drawingMode && (
            <AssignArea
              path={assignArea}
              refetch={reFetchTeamArea}
              closeDrawing={onDrawingClose}
            />
          )}

          {print && (
            <div>
              <button
                onClick={() => {
                  setPrint(false);
                  setPrintPath([]);
                }}
                className="btn btn-primary px-3 py-1 btn-rounded icon shadow add-listing  z-20 relative"
              >
                <FontAwesomeIcon icon={faMinus} />
                <span> Close</span>
              </button>
            </div>
          )}

          {selectedArea && userData?.team_owner && (
            <div>
              <button
                onClick={onDeleteArea}
                className="btn btn-primary px-3 py-1 btn-rounded icon shadow add-listing  z-20 relative"
              >
                <FontAwesomeIcon icon={faMinus} />
                <span> Delete Area</span>
              </button>
            </div>
          )}

          {selectedArea && userData?.team_owner && (
            <div>
              <button
                onClick={() => setEdit(true)}
                className="btn btn-primary px-3 py-1 btn-rounded icon shadow add-listing  z-20 relative"
              >
                <FontAwesomeIcon icon={faPen} />
                <span> Edit</span>
              </button>
            </div>
          )}

          {selectedArea && edit && userData?.team_owner && (
            <div>
              <button
                onClick={onSaveEdit}
                className="btn btn-primary px-3 py-1 btn-rounded icon shadow add-listing  z-20 relative"
              >
                <FontAwesomeIcon icon={faSave} />
                <span> Save</span>
              </button>
            </div>
          )}

          {path.length > 0 && (
            <div>
              <button
                onClick={() => {
                  dispatch(setCurrentRoute(null));
                }}
                className="btn btn-primary px-3 py-1 btn-rounded icon shadow add-listing  z-20 relative"
              >
                <FontAwesomeIcon icon={faMinus} />
                <span> Close Route</span>
              </button>
            </div>
          )}

          {path.length > 0 && (
            <div>
              <button
                onClick={() => {
                  setPrintPath(path);
                  setEditRoute(currentRoute);
                  setPrintProperties(JSON.parse(currentRoute.properties));
                  dispatch(setCurrentRoute(null));
                }}
                className="btn btn-primary px-3 py-1 btn-rounded icon shadow add-listing  z-20 relative"
              >
                <FontAwesomeIcon icon={faPen} />
                <span> Edit Route</span>
              </button>
            </div>
          )}

          <SaveRoute
            draw={draw}
            path={printPath}
            properties={printProperties}
            enableAutoOptimise={(val) => setAutoOptimizeRoute(val)}
            directions={directions}
            onRouteAdded={onRouteAdded}
            onRouteRemoved={onRouteRemoved}
            edit={editRoute}
          />
        </div>
      )}
      {newListingLocation && (
        <Suspense fallback={<Spinner />}>
          <AddListing
            latitude={newListingLocation.lat}
            longitude={newListingLocation.lng}
            open={true}
          />
        </Suspense>
      )}
      <GoogleMap
        mapContainerStyle={
          selectedListing !== null ||
          favoritesShow ||
          remindersShow ||
          routesShow ||
          teamActivityShow
            ? {
                height: "100%",
                width: "100%",
              }
            : {
                height: "100%",
                width: "100%",
              }
        }
        center={homeLocation}
        zoom={13}
        onLoad={onLoad}
        options={{
          styles: [
            {
              featureType: "poi",
              stylers: [{ visibility: "off" }],
            },
          ],
        }}
        onUnmount={onUnmount}
        onClick={handleMapClick}
        onCenterChanged={debounce(handleCenterChange, 500)}
        onZoomChanged={debounce(handleZoomChange, 500)}
      >
        {filteredListings.length > 0 && (
          <MarkerClustererF
            minimumClusterSize={10}
            onUnmount={(clusterer) => clusterer.clearMarkers()}
            onLoad={(clusterer) => (clustererRef.current = clusterer)}
            key={"marker-cluster"}
          >
            {(clusterer) =>
              filteredListings.map((listing: any) => {
                const position = {
                  lat: parseFloat(listing.latitude),
                  lng: parseFloat(listing.longitude),
                };
                let color = config.assetsUrl + "images/marker_pin_green.png";

                let appendIcon: string = "";

                if (
                  (hoveredListing &&
                    hoveredListing?.listing_unique_id &&
                    hoveredListing?.listing_unique_id ===
                      listing.listing_unique_id) ||
                  (clickedListing &&
                    clickedListing.listing_unique_id ===
                      listing.listing_unique_id)
                ) {
                  appendIcon = "_selected";
                }
                if (isWithinLast24Hours(listing.time_added)) {
                  color =
                    config.assetsUrl +
                    "images/marker_pin_new" +
                    appendIcon +
                    ".png";
                } else if (
                  listing.lead_status_options_public_id ===
                  "18744af2-7355-11ee-93c6-2cd7b0ee982d"
                ) {
                  color =
                    config.assetsUrl +
                    "images/marker_pin_green" +
                    appendIcon +
                    ".png";
                } else if (
                  listing.lead_status_options_public_id ===
                  "18749fd4-7355-11ee-93c6-2cd7b0ee982d"
                ) {
                  color =
                    config.assetsUrl +
                    "images/marker_pin_blue" +
                    appendIcon +
                    ".png";
                } else if (
                  listing.lead_status_options_public_id ===
                  "1874a1dc-7355-11ee-93c6-2cd7b0ee982d"
                ) {
                  color =
                    config.assetsUrl +
                    "images/marker_pin_red" +
                    appendIcon +
                    ".png";
                } else if (
                  listing.lead_status_options_public_id ===
                  "1874a272-7355-11ee-93c6-2cd7b0ee982d"
                ) {
                  color =
                    config.assetsUrl +
                    "images/marker_pin_pink" +
                    appendIcon +
                    ".png";
                } else if (
                  listing.lead_status_options_public_id ===
                  "1874a2b8-7355-11ee-93c6-2cd7b0ee982d"
                ) {
                  color =
                    config.assetsUrl +
                    "images/marker_pin_violet" +
                    appendIcon +
                    ".png";
                } else if (
                  listing.lead_status_options_public_id ===
                  "1874a2f4-7355-11ee-93c6-2cd7b0ee982d"
                ) {
                  color =
                    config.assetsUrl +
                    "images/marker_pin_orange" +
                    appendIcon +
                    ".png";
                } else if (
                  listing.lead_status_options_public_id ===
                  "1874a326-7355-11ee-93c6-2cd7b0ee982d"
                ) {
                  color =
                    config.assetsUrl +
                    "images/marker_pin_yellow" +
                    appendIcon +
                    ".png";
                } else if (
                  listing.lead_status_options_public_id ===
                  "1874a376-7355-11ee-93c6-2cd7b0ee982d"
                ) {
                  color =
                    config.assetsUrl +
                    "images/marker_pin_cyan" +
                    appendIcon +
                    ".png";
                } else if (
                  listing.lead_status_options_public_id ===
                  "1874a402-7355-11ee-93c6-2cd7b0ee982d"
                ) {
                  color =
                    config.assetsUrl +
                    "images/marker_pin_lightblue" +
                    appendIcon +
                    ".png";
                } else if (
                  listing.lead_status_options_public_id ===
                  "1874a466-7355-11ee-93c6-2cd7b0ee982d"
                ) {
                  color =
                    config.assetsUrl +
                    "images/marker_pin_grey" +
                    appendIcon +
                    ".png";
                } else if (
                  listing.lead_status_options_public_id ===
                  "1874a4ca-7355-11ee-93c6-2cd7b0ee982d"
                ) {
                  color =
                    config.assetsUrl +
                    "images/marker_pin_altred" +
                    appendIcon +
                    ".png";
                } else if (
                  listing.lead_status_options_public_id ===
                  "1874a51a-7355-11ee-93c6-2cd7b0ee982d"
                ) {
                  color =
                    config.assetsUrl +
                    "images/marker_pin_darkgreen" +
                    appendIcon +
                    ".png";
                } else if (
                  listing.lead_status_options_public_id ===
                  "b993b08a-45d6-4520-969d-60619dc45a0f"
                ) {
                  color =
                    config.assetsUrl +
                    "images/marker_pin_darkgreen" +
                    appendIcon +
                    ".png";
                }

                return (
                  <MarkerF
                    title={
                      listing.lead_status === ""
                        ? "Not available"
                        : listing.lead_status
                    }
                    key={"marker-" + listing.listing_unique_id}
                    /*icon={{
                                                path:
                                                    "M8 12l-4.7023 2.4721.898-5.236L.3916 5.5279l5.2574-.764L8 0l2.3511 4.764 5.2574.7639-3.8043 3.7082.898 5.236z",
                                                fillColor: color,
                                                fillOpacity: 0.9,
                                                scale: 2,
                                                strokeColor: color,
                                                strokeWeight: 2,
                                            }}*/
                    options={{
                      icon: color,
                    }}
                    position={position}
                    clusterer={clusterer}
                    onClick={(e) => markerClick(listing, e)}
                    noClustererRedraw={true}
                    onMouseOver={(e) => {
                      if (!logged) {
                        return;
                      }
                      setShowInfoWindow(true);
                      setActiveTooltipId(listing.listing_unique_id);
                    }}
                    onMouseOut={(e) => {
                      if (!logged) {
                        return;
                      }
                      setShowInfoWindow(false);
                      setActiveTooltipId("");
                    }}
                  >
                    {showInfoWindow &&
                      activeTooltipId === listing.listing_unique_id &&
                      clickedListing &&
                      clickedListing.listing_unique_id !==
                        listing.listing_unique_id &&
                      listing.listing_unique_id && (
                        <InfoWindowF
                          position={{ lat: listing.lat, lng: listing.lng }}
                          key={"active-" + activeTooltipId}
                        >
                          <div className={"map-info-tip"}>
                            <div className={"map-image"}>
                              <img
                                width={"100%"}
                                src={
                                  "https://maps.googleapis.com/maps/api/streetview?size=356x200&location=" +
                                  listing.latitude +
                                  "," +
                                  listing.longitude +
                                  "&key=AIzaSyCclBCu30QD5vsNQKwg8PKrn2EofxY6YP4&source=outdoor"
                                }
                              />
                            </div>
                            <div
                              className={
                                isFavorited(listing)
                                  ? "map-item-favorite favorited"
                                  : "map-item-favorite"
                              }
                            >
                              <FontAwesomeIcon
                                icon={faStar}
                                size={"lg"}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  e.preventDefault();
                                  doActionFavorites(listing);
                                }}
                              />
                            </div>
                            <h4>{listing.address}</h4>
                            <div className={"lead-status"}>
                              Lead Status:{" "}
                              {listing.lead_status === ""
                                ? "Not available"
                                : listing.lead_status}
                            </div>
                          </div>
                        </InfoWindowF>
                      )}
                    {/*{(hoveredListing && hoveredListing?.listing_unique_id && hoveredListing?.listing_unique_id === listing.listing_unique_id) &&
                                                <InfoWindowF position={{lat: listing.lat, lng: listing.lng}}>
                                                    <div className={"map-info-tip"}>
                                                        <div className={'map-image'}>
                                                            <img width={'100%'}
                                                                 src={'https://maps.googleapis.com/maps/api/streetview?size=356x200&location=' + listing.latitude + ',' + listing.longitude + '&fov=60&heading=30&pitch=0&key=AIzaSyCclBCu30QD5vsNQKwg8PKrn2EofxY6YP4'}/>
                                                        </div>
                                                        <h4>{listing.address}</h4>
                                                        <div className={'lead-status'}>Lead
                                                            Status: {listing.lead_status === '' ? 'Not available' : listing.lead_status}</div>
                                                    </div>
                                                </InfoWindowF>
                                            }*/}
                    {clickedListing &&
                      clickedListing.listing_unique_id ===
                        listing.listing_unique_id &&
                      listing.listing_unique_id && (
                        <InfoWindowF
                          position={{
                            lat: clickedListing.lat,
                            lng: clickedListing.lng,
                          }}
                          key={"clicked-" + clickedListing.listing_unique_id}
                        >
                          <div
                            className={"map-info-tip clickable-tooltip"}
                            onClick={(e) => handleClickTooltip(clickedListing)}
                          >
                            <div className={"map-image"}>
                              <img
                                width={"100%"}
                                src={
                                  "https://maps.googleapis.com/maps/api/streetview?size=356x200&location=" +
                                  clickedListing.latitude +
                                  "," +
                                  clickedListing.longitude +
                                  "&key=AIzaSyCclBCu30QD5vsNQKwg8PKrn2EofxY6YP4&source=outdoor"
                                }
                              />
                            </div>
                            <div
                              className={
                                isFavorited(listing)
                                  ? "map-item-favorite favorited"
                                  : "map-item-favorite"
                              }
                            >
                              <FontAwesomeIcon
                                icon={faStar}
                                size={"lg"}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  e.preventDefault();
                                  doActionFavorites(listing);
                                }}
                              />
                            </div>
                            <h4>{clickedListing.address}</h4>
                            <div className={"lead-status"}>
                              Lead Status:{" "}
                              {clickedListing.lead_status === ""
                                ? "Not available"
                                : clickedListing.lead_status}
                            </div>
                          </div>
                        </InfoWindowF>
                      )}
                  </MarkerF>
                );
              })
            }
          </MarkerClustererF>
        )}
        <MarkerF
          key={"marker-my-location"}
          options={{
            icon: config.assetsUrl + "images/current.png",
          }}
          position={homeLocation}
        />
        {/*{newListingLocation && true && <MarkerF position={newListingLocation}/>}*/}
        {/*{!isStreetView && logged && routeEnabled &&
                    <DirectionsService
                        options={{
                            destination: destinations[destinations.length - 1].value,
                            origin: source,
                            waypoints: waypoints,
                            optimizeWaypoints: autoOptimizeRoute,
                            travelMode: google.maps.TravelMode.DRIVING
                        }}
                        callback={directionsCallback}
                    />
                }*/}
        {!isStreetView && logged && directions && autoOptimizeRoute && (
          <DirectionsRenderer
            directions={directions}
            options={{
              preserveViewport: true,
            }}
          />
        )}
        {printPath.length > 1 && (
          <PolylineF
            key="print-path"
            options={{ strokeColor: "#000000", path: printPath }}
          />
        )}
        <PolylineF path={path} options={{ strokeColor: "#FF0000" }} />
        {/*{!isStreetView && logged && directionsResponse && routeEnabled && (
                    <DirectionsRenderer
                        options={{
              directions: directions,
              draggable: true,
            }}
          />
                )}*/}
        <DrawingManagerF
          onLoad={onLoadDrawing}
          options={{
            drawingControl: false, // Disable default drawing control
            drawingMode: null, // Initially, drawing mode is off
            polygonOptions: {
              fillColor: "#199ee0",
              fillOpacity: 0.2,
              strokeWeight: 2,
              strokeColor: "#113460",
              clickable: true,
              editable: true,
              geodesic: false,
              visible: true,
              zIndex: 1,
            },
          }}
          onOverlayComplete={(event) => {
            const path = (event.overlay as any)
              ?.getPath()
              ?.getArray()
              ?.map((itm: any) => ({ lat: itm.lat(), lng: itm.lng() }));

            setAssignArea(path);
            setPolygonOverlay(event.overlay);
            // (event.overlay as any)?.getPath().forEach((itm: any) => {
            //   console.log({ lat: itm.lat(), lng: itm.lng() });
            // });
          }}
        />

        {teamArea?.data?.map((area: any) => {
          // Calculate the center of the polygon
          const coordinates = JSON.parse(area.area_cordinates);
          let bounds = new window.google.maps.LatLngBounds();
          coordinates.forEach(function (coord: any) {
            bounds.extend(coord);
          });
          const center = bounds.getCenter();

          return (
            <div key={area.area_public_id}>
              <AreaPolygon
                area={area}
                paths={coordinates}
                selectedArea={selectedArea}
                setSelectedArea={setSelectedArea}
                edit={edit}
                setSelectedPolygon={setSelectedPolygon}
              />
              <OverlayViewF mapPaneName="mapPane" position={center}>
                <div className="text-lg text-blue font-medium">
                  {area.user_fname}
                </div>
              </OverlayViewF>
            </div>
          );
        })}

        {myArea?.data?.map((area: any) => {
          // Calculate the center of the polygon
          let bounds = new window.google.maps.LatLngBounds();

          // area.area_cordinates.forEach(function (coord: any) {
          //   bounds.extend(coord);
          // });
          const center = bounds.getCenter();

          return (
            <div key={area.area_name}>
              <PolygonF
                paths={area.area_cordinates}
                options={{
                  strokeColor: "#1D4ED8", // generate random color hex
                  strokeOpacity: 0.8,
                  strokeWeight: 2,
                  fillOpacity: 0.35,
                }}
              />
              <OverlayViewF mapPaneName="mapPane" position={center}>
                <div className="text-lg text-blue font-medium">
                  {area.area_name || ""}
                </div>
              </OverlayViewF>
            </div>
          );
        })}
      </GoogleMap>
      {showEditArea && selectedArea && selectedPolygon ? (
        <EditArea
          area={{
            ...selectedArea,
            area_cordinates: selectedPolygon
              .getPath()
              .getArray()
              .map((latLng: any) => {
                return { lat: latLng.lat(), lng: latLng.lng() };
              }),
          }}
          closeDrawing={onDrawingClose}
          onclose={() => {
            setShowEditArea(false);
            setEdit(false);
          }}
          refetch={reFetchTeamArea}
        />
      ) : null}
    </div>
  ) : (
    <></>
  );
};

export default React.memo(GoogleMapContainer);
